import { Divider } from "@chakra-ui/react";

const DividerWithSpacing = ({ my = 6 }) => (
  <Divider borderColor="transparent" my={my} />
);

export default DividerWithSpacing;
